import React, { useState } from "react";
import NormalTable from "components/Organisms/tables/normal-table";
import { getReviewColumnDef } from "../../constants";
import { useGetColumnSearchProps } from "components/Organisms/tables/table-hook";
import { useNavigate } from "react-router-dom";

export const ReviewTable = ({
  dataSource,
  filters = {},
  defaultFilteredValue = {},
  ...tableProps
}: any) => {
  const navigate = useNavigate();
  const [getColumnSearchProps] = useGetColumnSearchProps();
  const columns = getReviewColumnDef(
    navigate,
    getColumnSearchProps,
    defaultFilteredValue,
    filters
  );

  return (
    <NormalTable
      {...tableProps}
      columns={columns}
      dataSource={dataSource}
      rowKey={(record) => record.id}
    ></NormalTable>
  );
};
